import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoundedBorderService {

  classes(
    {
      roundedClass = 'rounded-lg',
      borderClass = 'border-2',
      borderColorClasses = ['border-j-border-secondary'],
    }: {
      roundedClass?: string;
      borderClass?: string;
      borderColorClasses?: string[];
    } = {},
  ): string[] {
    const classes: string[] = [
      borderClass,
      'border-solid',
      ...borderColorClasses,
      roundedClass,
    ];
    return classes;
  }
}
